
export const errorMessages: Map<string, string>  = new Map<string, string>([
        ['default', 'Une erreur est survenue']
    ]);
